import { DeleteButton as Delete } from './delete'
import { EditButton as Edit } from './edit'
import { SitGuestVaul as SitGuest } from './sit'

export const ReservationRequest = {
  SitGuest,
  Delete,
  Edit
}
